import { Backdrop, Button, Stack, Typography } from "@mui/material"
import MainCard from "../../common/main-card"
import { useState } from "react"
import { TickCircle } from "iconsax-react"
import { convertToPersianDate } from "../../../utils/ConvertToPersianDate"

// -------------------------------------------------||  CLUB PLAN MODAL- COMPONENTS ||-------------------------------------------------

const ClubPlanModal = ({ open, code, expiredDate, setShowClubModal }) => {
  const handleClose = () => {
    setShowClubModal(false)
  }
  return (
    <Backdrop open={open} sx={{ zIndex: 1000000 }} fullWidth={true}>
      <MainCard shadow={3} sx={{ px: 6, py: 3, borderRadius: "18px", zIndex: 10000000, cursor: "pointer" }}>
        <Stack spacing={3} sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <TickCircle color='green' size={40} />
          <Typography textAlign='center' color='green' variant='h4' fontWeight='bold'>
            کاربر گرامی، کد تخفیف شما با موفقیت دریافت شد!
          </Typography>
          <Typography variant='subtitle1' fontSize={13}>
            کدشما: {code}
          </Typography>
          <Typography variant='subtitle1' fontSize={13}>
            تاریخ اعتبار: {convertToPersianDate(expiredDate, "jYYYY/jMM/jDD")}
          </Typography>
          <Button
            color='primary'
            variant='contained'
            size='medium'
            sx={{ borderRadius: "8px", width: "100%" }}
            onClick={handleClose}
          >
            متوجه شدم
          </Button>
        </Stack>
      </MainCard>
    </Backdrop>
  )
}
export default ClubPlanModal
